__webpack_require__.p = "/Gyk-React-App/";